import React from 'react';
import logo from "../../../assets/images/logo2.png";
import T from 'prop-types';

export const Logo2 = ({ className }) => {
    return <img src={logo} className={className} alt="Logo image" />;
};

Logo2.T = {
    className: T.string,
};

Logo2.defaultProps = {
    className: 'logoDefaultCls',
};
